import { useRouter } from 'next/dist/client/router';
import { Dispatch } from 'react';
import Times from '../../../icons/Times';

interface ActiveFilterProps {
  filter: string;
  paramLabel: string;
  setPage: Dispatch<number>;
}

const ActiveFilter: React.FC<ActiveFilterProps> = ({ filter, paramLabel, setPage }) => {
  const router = useRouter();
  const removeFilter = () => {
    const params = router.query;
    const filterArray = (params[paramLabel] as string)?.split('_');
    const newArray = filterArray?.filter((val) => val != filter);
    if (newArray?.length) {
      params[paramLabel] = newArray.join('_');
    } else {
      delete params[paramLabel];
    }
    setPage(1)
    router.replace(router, undefined, { scroll: false });
  };
  return (
    <button className="flex items-center justify-between w-auto px-2 py-1 text-xs text-left text-white rounded-sm bg-careerPageLight font-base">
      {filter}
      <Times
        className="w-3 h-3 cursor-pointer stroke-white"
        onClick={removeFilter}
      />
    </button>
  );
};

export default ActiveFilter;
